import IKey from '../Interfaces/IKey';

import ReservedValue from './ReservedValue';

const COLUMN_BASIS = 100 / 15;

const alphanumericKeyset: IKey[] = [
    {key: 0, value: 'A', basis: COLUMN_BASIS * 2, anchors: [75]},
    {key: 1, value: 'B'},
    {key: 2, value: 'C'},
    {key: 3, value: 'D'},
    {key: 4, value: 'E'},
    {key: 5, value: 'F'},
    {key: 6, value: 'G'},
    {key: 7, value: 'H'},
    {key: 8, value: 'I'},
    {key: 9, value: 'J'},
    {key: 10, value: 'K'},
    {key: 11, value: 'L'},
    {key: 12, value: 'M', basis: COLUMN_BASIS * 2, anchors: [25]},
    {key: 13, value: ReservedValue.SPACE},
    {key: 14, value: 'N'},
    {key: 15, value: 'O'},
    {key: 16, value: 'P'},
    {key: 17, value: 'Q'},
    {key: 18, value: 'R'},
    {key: 19, value: 'S'},
    {key: 20, value: 'T'},
    {key: 21, value: 'U'},
    {key: 22, value: 'V'},
    {key: 23, value: 'W'},
    {key: 24, value: 'X'},
    {key: 25, value: 'Y'},
    {key: 26, value: 'Z'},
    {key: 27, value: ReservedValue.BACKSPACE},
    {key: 28, value: ReservedValue.DIACRITICS},
    {key: 29, value: '1', focusableIndex: 1},
    {key: 30, value: '2'},
    {key: 31, value: '3'},
    {key: 32, value: '4'},
    {key: 33, value: '5'},
    {key: 34, value: '6'},
    {key: 35, value: '7'},
    {key: 36, value: '8'},
    {key: 37, value: '9'},
    {key: 38, value: '0'},
    {key: 39, value: '.'},
    {key: 40, value: '-', basis: COLUMN_BASIS * 3, anchors: [15]},
];

const diacriticsKeyset: IKey[] = [
    {key: 0, value: 'ß', basis: COLUMN_BASIS * 2, anchors: [75]},
    {key: 1, value: 'À'},
    {key: 2, value: 'Á'},
    {key: 3, value: 'Â'},
    {key: 4, value: 'Ã'},
    {key: 5, value: 'Ä'},
    {key: 6, value: 'Å'},
    {key: 7, value: 'Æ'},
    {key: 8, value: 'Œ'},
    {key: 9, value: 'Ý'},
    {key: 10, value: '¿'},
    {key: 11, value: 'È'},
    {key: 12, value: 'É', basis: COLUMN_BASIS * 2},
    {key: 13, value: ReservedValue.SPACE},
    {key: 14, value: 'Ê'},
    {key: 15, value: 'Ë'},
    {key: 16, value: 'Ì'},
    {key: 17, value: 'Í'},
    {key: 18, value: 'Î'},
    {key: 19, value: 'Ï'},
    {key: 20, value: 'Ð'},
    {key: 21, value: 'Ñ'},
    {key: 22, value: '¡'},
    {key: 23, value: 'Ò'},
    {key: 24, value: 'Ó'},
    {key: 25, value: 'Ô'},
    {key: 26, value: 'Õ'},
    {key: 27, value: ReservedValue.BACKSPACE},
    {key: 28, value: ReservedValue.ALPHANUMERIC, basis: COLUMN_BASIS * 2},
    {key: 30, value: 'Ö'},
    {key: 31, value: 'Ø'},
    {key: 32, value: 'Š'},
    {key: 33, value: 'Ù'},
    {key: 34, value: 'Ú'},
    {key: 35, value: 'Û'},
    {key: 36, value: 'Ü'},
    {key: 37, value: 'Ý'},
    {key: 38, value: 'Ÿ'},
    {key: 39, value: 'Ž'},
    {key: 40, value: 'Þ', basis: COLUMN_BASIS * 3, anchors: [15]},
];

export {alphanumericKeyset, diacriticsKeyset};
